import { apiRequestFactoryVuex } from '@dr-max/vue-http'

import i18nWrapper from '@/plugins/i18n'
import { formPartAResource, formPartBResource, managementResource } from '@/services/okFormResource'
import { getTokenState } from '@/services/validateToken.ts'
import { FormState, FormAState } from '@/models/enums'

const buildErrorTitle = (...parts) => {
  return parts.filter((p) => p).join(' - ')
}

function notifyError(_vm, err, requestTitle) {
  const i18n = i18nWrapper.getI18n()
  const { response } = err
  const titleTranslation = i18n.te(requestTitle) && i18n.t(requestTitle)

  if (response) {
    const { status, data } = response
    const text = (data && data.detail) || i18n.t(`api.errorStatus.${status}`)
    _vm.$notify({
      title: buildErrorTitle(titleTranslation, `${i18n.t('api.error')} ${status}`),
      text,
      type: 'danger',
    })
  } else {
    _vm.$notify({
      title: buildErrorTitle(titleTranslation, i18n.t('api.error')),
      text: i18n.t('api.serverOrNetworkError'),
      type: 'danger',
    })
  }
}

const vuexModule = {
  state: {
    formState: null,
    wasValidated: {
      formPartA: false,
      formPartB: false,
    },
  },
  getters: {
    isFormAOpen(state) {
      if (!state.formState) return null
      const { formState, formAState } = state.formState
      return formState === FormState.OPEN && formAState === FormAState.OPEN
    },
    isFormBOpen(state) {
      if (!state.formState) return null
      const { formState } = state.formState
      return formState === FormState.OPEN
    },
    isFormReadyToImport(state) {
      const { formState } = state.formState || {}
      return formState === FormState.READY_TO_IMPORT
    },
    isFormClosed(state) {
      const { formState } = state.formState || {}
      return formState === FormState.CLOSED
    },
    isFormCancelled(state) {
      const { formState } = state.formState || {}
      return formState === FormState.CANCELLED
    },

    formStateError(state) {
      return state.formState && state.formState.error
    },

    formAWasValidated(state) {
      return state.wasValidated.formPartA
    },
    formBWasValidated(state) {
      return state.wasValidated.formPartB
    },
  },
  mutations: {
    formState(state, formState) {
      state.formState = formState
    },

    formAWasValidated(state, value) {
      state.wasValidated.formPartA = value
    },
    formBWasValidated(state, value) {
      state.wasValidated.formPartA = value
    },
  },
  actions: {
    async fetchState({ commit }, { formId, noCheck }) {
      commit('formState', await getTokenState(formId, noCheck))
    },

    async fetchFormPartAWithHandler({ dispatch }, payload) {
      const response = await dispatch('fetchFormPartA', payload)
      const { hasError, error } = response

      if (hasError) {
        notifyError(this._vm, error, 'management.action.readFormPartA')
      }

      return response
    },

    async fetchFormPartBWithHandler({ dispatch }, payload) {
      const response = await dispatch('fetchFormPartB', payload)
      const { hasError, error } = response

      if (hasError) {
        notifyError(this._vm, error, 'management.action.readFormPartB')
      }

      return response
    },

    async fetchFormDetailWithHandler({ dispatch }, payload) {
      const response = await dispatch('fetchFormDetail', payload)
      const { hasError, error } = response

      if (hasError) {
        notifyError(this._vm, error, 'management.action.readFormDetail')
      }

      return response
    },

    async confirmImportWithHandler({ dispatch }, payload) {
      const response = await dispatch('confirmImport', payload)
      const { hasError, error } = response

      if (hasError) {
        notifyError(this._vm, error, 'questionFormCommon.action.importToOk.title')
      }

      return response
    },

    async cancelFormWithHandler({ dispatch }, payload) {
      const response = await dispatch('cancelForm', payload)
      const { hasError, error } = response

      if (hasError) {
        notifyError(this._vm, error, 'questionFormCommon.action.cancel.title')
      }

      return response
    },
  },
}

apiRequestFactoryVuex(vuexModule)
  .addApiRequest('formPartA', formPartAResource.fetchData, {
    disableApiErrorNotify: true,
    disableNetworkErrorNotify: true,
  })
  .addApiRequest('formPartB', formPartBResource.fetchData, {
    disableApiErrorNotify: true,
    disableNetworkErrorNotify: true,
  })
  .addApiRequest('formDetail', managementResource.fetchDetail, {
    disableApiErrorNotify: true,
    disableNetworkErrorNotify: true,
  })
  .addApiRequest('confirmImport', managementResource.confirmImport, {
    noPrefix: true,
    disableApiErrorNotify: true,
    disableNetworkErrorNotify: true,
  })
  .addApiRequest('cancelForm', managementResource.cancelForm, {
    noPrefix: true,
    disableApiErrorNotify: true,
    disableNetworkErrorNotify: true,
  })

export default {
  state: () => vuexModule.state,
  getters: vuexModule.getters,
  mutations: vuexModule.mutations,
  actions: vuexModule.actions,
}
